import "./MfaModal.css";
import { QRCodeCanvas } from "qrcode.react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

require("dotenv").config();
const BASE_URL = process.env.REACT_APP_BASE_URL
  ? process.env.REACT_APP_BASE_URL.replace("v1", "v2")
  : "http://localhost:5002/api/v2";

const MfaSetupModal = ({ isOpen, onClose, email, accessToken }) => {
  const [secret, setSecret] = useState();
  const [otpAuthUrl, setOtpAuthUrl] = useState();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [enterCodeError, setEnterCodeError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    setOtpAuthUrl("");
    setCode("");
    setSecret("");
    setEnterCodeError("");
    fetchMfaSetup();
  }, [isOpen]);

  const fetchMfaSetup = async () => {
    try {
      const response = await fetch(`${BASE_URL}/users/mfa/setup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, accessToken }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        toast.info(data.message);
        return;
      }

      setSecret(data.secretCode);
      setOtpAuthUrl(data.otpAuthUrl);
      setCode("");
      setLoading(false);
    } catch (error) {
      console.error("MFA setup failed:", error?.response?.status ?? error.message);
    }
  };

  const handleVerify = async () => {
    if (code.length !== 6) {
      setEnterCodeError("Enter a 6-digit code.");
      return;
    }
    try {
      const response = await fetch(`${BASE_URL}/users/mfa/verify-setup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken, code }),
      });
      const data = await response.json();

      if (response.ok && data.success) {
        toast.success("MFA enabled successfully!");
        onClose();
      } else {
        setEnterCodeError("Incorrect code. Try again.");
      }
    } catch (error) {
      toast.error("Error verifying MFA code.");
      console.error("MFA code verification failed:", error?.response?.status ?? error.message);
    }
  };

  return (
    isOpen && (
      <div className="mfaModalBackdrop">
        <div className="mfaModal">
          <h3>Keep your account safe with 2-factor authentication</h3>
          <p>
            Scan this QR code with an authenticator app on your mobile device,
            then submit the code to set up your account.
          </p>

          {otpAuthUrl ? (
            <QRCodeCanvas value={otpAuthUrl} size={150} />
          ) : (
            <p>Loading QR code...</p>
          )}

          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            maxLength="6"
            style={{
              fontSize: "1.5rem",
              textAlign: "center",
            }}
          />
          {enterCodeError && <p className="errorMessage">{enterCodeError}</p>}
          {/* #798: Submit sits directly under the code box. The long manual
              secret used to sit between them and pushed Submit below the
              bottom edge of a short window. */}
          <div className="mfaSubmit mfaSubmitSticky">
            <button onClick={onClose} className="btn-primary loginButtonUnique">
              Cancel
            </button>
            <button
              onClick={handleVerify}
              className="btn-primary loginButtonUnique"
              disabled={loading}
            >
              Submit
            </button>
          </div>
          <details className="mfaCodeSection">
            <summary>Can&apos;t scan? Enter a code instead</summary>
            <p>
              Enter this code manually into your authenticator app
              <br />
              <code>{secret}</code>
            </p>
          </details>
        </div>
      </div>
    )
  );
};

export default MfaSetupModal;
